/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { addFilter } from '@wordpress/hooks';
import { InspectorControls } from '@wordpress/block-editor';
import { ToggleControl, PanelBody, PanelRow } from '@wordpress/components';

/**
 * Add the attributes needed for hiding the content on mobile or desktop.
 *
 * @since 1.0
 * @param {Object} settings
 */
function addAttributes( settings ) {

	// Add the attributes.
	const blockAttributes = {
		HideOnMobile: {
			type: 'boolean',
			default: false,
		},
		HideOnDesktop: {
			type: 'boolean',
			default: false,
		},
		HideToLogged: {
			type: 'boolean',
			default: false,
		},
		HideToNotLogged: {
			type: 'boolean',
			default: false,
		}
	};

	const newSettings = {
		...settings,
		attributes: {
			...settings.attributes,
			...blockAttributes,
		},
	};

	return newSettings;
}

addFilter(
	'blocks.registerBlockType',
	'osom-block-visibility/add-attributes',
	addAttributes
);

/**
 * Filter the BlockEdit object and add a panel with the toggles that control content visibility.
 *
 * @since 1.0
 * @param {Object} BlockEdit
 */
function addInspectorControls( BlockEdit ) {
	return ( props ) => {

		const { attributes, setAttributes } = props;
		const { HideOnMobile, HideOnDesktop, HideToLogged, HideToNotLogged } = attributes;

		return (
			<>
				<BlockEdit {...props} />
				<InspectorControls>
					<PanelBody title="Visibility Settings" initialOpen={false}>
					<PanelRow>
					<ToggleControl
								label={__(
									'Hide on desktop',
									'hide-on-desktop'
								)}
								checked={HideOnDesktop}
								onChange={() => {
									setAttributes({
										HideOnDesktop:
											!HideOnDesktop,
									});
								}}
							/>
						</PanelRow>
						<PanelRow>
							<ToggleControl
								label={__(
									'Hide on mobile and tablet',
									'hide-on-mobile-and-tablet'
								)}
								checked={HideOnMobile}
								onChange={() => {
									setAttributes({
										HideOnMobile:
											!HideOnMobile,
									});
								}}
							/>
						</PanelRow>
						<PanelRow>
							<ToggleControl
								label={__(
									'Hide to loggedin users',
									'hide-to-loggedin-users'
								)}
								checked={HideToLogged}
								onChange={(checked) => {
									setAttributes({
										HideToLogged:
											!HideToLogged,
									});
								}}
							/>
						</PanelRow>
						<PanelRow>
							<ToggleControl
								label={__(
									'Hide to loggedout users',
									'hide-to-loggedout-users'
								)}
								checked={HideToNotLogged}
								onChange={(checked) => {
									setAttributes({
										HideToNotLogged:
											!HideToNotLogged,
									});
								}}
							/>
						</PanelRow>
					</PanelBody>
				</InspectorControls>
			</>
		);
	};
}

addFilter(
	'editor.BlockEdit',
	'osom-block-visibility/add-inspector-controls',
	addInspectorControls
);